(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8656],{

/***/ 1646:
/***/ (function(module) {

!function(t,s){ true?module.exports=s():0}(this,(function(){"use strict";var t,s,n=1e3,i=6e4,e=36e5,r=864e5,o=31536e6,u=2628e6,d=/^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/,a=/\[([^\]]+)]|YYYY|YY|Y|M{1,2}|D{1,2}|H{1,2}|m{1,2}|s{1,2}|SSS/g,h={years:o,months:u,days:r,hours:e,minutes:i,seconds:n,milliseconds:1,weeks:6048e5},c=function(t){return t instanceof g},f=function(t,s,n){return new g(t,n,s.$l)},m=function(t){return s.p(t)+"s"},l=function(t){return t<0},$=function(t){return l(t)?Math.ceil(t):Math.floor(t)},y=function(t){return Math.abs(t)},v=function(t,s){return t?l(t)?{negative:!0,format:""+y(t)+s}:{negative:!1,format:""+t+s}:{negative:!1,format:""}},g=function(){function l(t,s,n){var i=this;if(this.$d={},this.$l=n,void 0===t&&(this.$ms=0,this.parseFromMilliseconds()),s)return f(t*h[m(s)],this);if("number"==typeof t)return this.$ms=t,this.parseFromMilliseconds(),this;if("object"==typeof t)return Object.keys(t).forEach((function(s){i.$d[m(s)]=t[s]})),this.calMilliseconds(),this;if("string"==typeof t){var e=t.match(d);if(e){var r=e.slice(2).map((function(t){return null!=t?Number(t):0}));return this.$d.years=r[0],this.$d.months=r[1],this.$d.weeks=r[2],this.$d.days=r[3],this.$d.hours=r[4],this.$d.minutes=r[5],this.$d.seconds=r[6],this.calMilliseconds(),this}}return this}var y=l.prototype;return y.calMilliseconds=function(){var t=this;this.$ms=Object.keys(this.$d).reduce((function(s,n){return s+(t.$d[n]||0)*h[n]}),0)},y.parseFromMilliseconds=function(){var t=this.$ms;this.$d.years=$(t/o),t%=o,this.$d.months=$(t/u),t%=u,this.$d.days=$(t/r),t%=r,this.$d.hours=$(t/e),t%=e,this.$d.minutes=$(t/i),t%=i,this.$d.seconds=$(t/n),t%=n,this.$d.milliseconds=t},y.toISOString=function(){var t=v(this.$d.years,"Y"),s=v(this.$d.months,"M"),n=+this.$d.days||0;this.$d.weeks&&(n+=7*this.$d.weeks);var i=v(n,"D"),e=v(this.$d.hours,"H"),r=v(this.$d.minutes,"M"),o=this.$d.seconds||0;this.$d.milliseconds&&(o+=this.$d.milliseconds/1e3,o=Math.round(1e3*o)/1e3);var u=v(o,"S"),d=t.negative||s.negative||i.negative||e.negative||r.negative||u.negative,a=e.format||r.format||u.format?"T":"",h=(d?"-":"")+"P"+t.format+s.format+i.format+a+e.format+r.format+u.format;return"P"===h||"-P"===h?"P0D":h},y.toJSON=function(){return this.toISOString()},y.format=function(t){var n=t||"YYYY-MM-DDTHH:mm:ss",i={Y:this.$d.years,YY:s.s(this.$d.years,2,"0"),YYYY:s.s(this.$d.years,4,"0"),M:this.$d.months,MM:s.s(this.$d.months,2,"0"),D:this.$d.days,DD:s.s(this.$d.days,2,"0"),H:this.$d.hours,HH:s.s(this.$d.hours,2,"0"),m:this.$d.minutes,mm:s.s(this.$d.minutes,2,"0"),s:this.$d.seconds,ss:s.s(this.$d.seconds,2,"0"),SSS:s.s(this.$d.milliseconds,3,"0")};return n.replace(a,(function(t,s){return s||String(i[t])}))},y.as=function(t){return this.$ms/h[m(t)]},y.get=function(t){var s=this.$ms,n=m(t);return"milliseconds"===n?s%=1e3:s="weeks"===n?$(s/h[n]):this.$d[n],s||0},y.add=function(t,s,n){var i;return i=s?t*h[m(s)]:c(t)?t.$ms:f(t,this).$ms,f(this.$ms+i*(n?-1:1),this)},y.subtract=function(t,s){return this.add(t,s,!0)},y.locale=function(t){var s=this.clone();return s.$l=t,s},y.clone=function(){return f(this.$ms,this)},y.humanize=function(s){return t().add(this.$ms,"ms").locale(this.$l).fromNow(!s)},y.valueOf=function(){return this.asMilliseconds()},y.milliseconds=function(){return this.get("milliseconds")},y.asMilliseconds=function(){return this.as("milliseconds")},y.seconds=function(){return this.get("seconds")},y.asSeconds=function(){return this.as("seconds")},y.minutes=function(){return this.get("minutes")},y.asMinutes=function(){return this.as("minutes")},y.hours=function(){return this.get("hours")},y.asHours=function(){return this.as("hours")},y.days=function(){return this.get("days")},y.asDays=function(){return this.as("days")},y.weeks=function(){return this.get("weeks")},y.asWeeks=function(){return this.as("weeks")},y.months=function(){return this.get("months")},y.asMonths=function(){return this.as("months")},y.years=function(){return this.get("years")},y.asYears=function(){return this.as("years")},l}(),p=function(t,s,n){return t.add(s.years()*n,"y").add(s.months()*n,"M").add(s.days()*n,"d").add(s.hours()*n,"h").add(s.minutes()*n,"m").add(s.seconds()*n,"s").add(s.milliseconds()*n,"ms")};return function(n,i,e){t=e,s=e().$utils(),e.duration=function(t,s){var n=e.locale();return f(t,{$l:n},s)},e.isDuration=c;var r=i.prototype.add,o=i.prototype.subtract;i.prototype.add=function(t,s){return c(t)?p(this,t,1):r.bind(this)(t,s)},i.prototype.subtract=function(t,s){return c(t)?p(this,t,-1):o.bind(this)(t,s)}}}));

/***/ }),

/***/ 92977:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/screen-time",
      function () {
        return __webpack_require__(50360);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cq": function() { return /* binding */ getCode; },
/* harmony export */   "DF": function() { return /* binding */ androidLocalRefresh; },
/* harmony export */   "LW": function() { return /* binding */ localShooting; },
/* harmony export */   "UC": function() { return /* binding */ localPhoneSendEmailios; },
/* harmony export */   "ds": function() { return /* binding */ CheckCode; },
/* harmony export */   "gM": function() { return /* binding */ checkAppLastVersion; },
/* harmony export */   "lm": function() { return /* binding */ localPhoneSendEmailandroid; },
/* harmony export */   "sk": function() { return /* binding */ setBlock; },
/* harmony export */   "zW": function() { return /* binding */ androidLocalRecordQuestionRrecycleGet; }
/* harmony export */ });
/* unused harmony exports localPhoneSendEmail, androidLocalAsyncDataStatus */
/* harmony import */ var _src_utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93103);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);


//apk注册码
const getCode = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/user/get-device-code", options);
//apk验证注册码是否绑定
const CheckCode = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/user/check-device-code", options);
// 判断本地app是否最新版本
const checkAppLastVersion = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/get-app/version?" + qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(options));
// 本地app请求刷新
const androidLocalRefresh = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/device/android-local-reset-data", options);
// 本地app录制状态获取
const androidLocalRecordQuestionRrecycleGet = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/device/android-local-record-question-recycle-get?" + qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(options));
//AndRoid-Local选择moto机型时发送邮件
const localPhoneSendEmail = (options)=>axios.post("/api/definition/target-phone", options);
const localPhoneSendEmailios = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/definition/target-ios-phone", options);
const localPhoneSendEmailandroid = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/definition/target-android-phone", options);
//Block app && Block wifi获取应用解锁状态
const setBlock = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/device/android-local-device-type-limit", options);
//take photos && record video轮训消息
const localShooting = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/a-local-shooting-log", {
        params: options
    });
// apk同步下载数据轮询状态
const androidLocalAsyncDataStatus = (options)=>axios.post("/api/device/android-local-async-data-status", options);


/***/ }),

/***/ 74743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74249);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__);




const ContentLoading = (param)=>{
    let { label , fullScreen =false , className =""  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const text = label || t("Loading...");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        role: "status",
        "aria-live": "polite",
        "aria-label": text,
        className: "".concat((_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRoot), " ").concat(fullScreen ? (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRootFullScreen) : "", " ").concat(className).trim(),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: "/images/loading/spinner.svg",
                alt: "",
                width: 64,
                height: 64,
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingSpinner),
                "aria-hidden": "true",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingLabel),
                children: text
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentLoading);


/***/ }),

/***/ 82017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useDeviceScopedInit; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34745);



/**

 * 当前选中设备变化时重新执行初始化逻辑（拉数、重置本地 state 等）。

 * 通过 requestKey 与 AbortSignal 丢弃切换前未完成的异步请求。

 *

 * @param {(deviceUser: string, scope: {

 *   context: Object,

 *   signal: AbortSignal,

 *   isCurrent: () => boolean

 * }) => void} initFn - 设备作用域初始化回调，需 useCallback 包裹

 */ function useDeviceScopedInit(initFn) {
    const deviceUser = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((state)=>state.Common.deviceUser);
    const context = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceContext */ .VQ);
    const requestKey = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceRequestKey */ .rx);
    const contextRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(context);
    contextRef.current = context;
    const effectiveDeviceUser = deviceUser || (context === null || context === void 0 ? void 0 : context.accountId) || (context === null || context === void 0 ? void 0 : context.username);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!effectiveDeviceUser) return;
        const controller = new AbortController();
        let active = true;
        const scopedContext = contextRef.current;
        // 仅当 requestKey 仍与当前 Redux 一致时，才应用异步结果
        const isCurrent = ()=>{
            var ref;
            return active && !controller.signal.aborted && ((ref = contextRef.current) === null || ref === void 0 ? void 0 : ref.requestKey) === requestKey;
        };
        initFn(effectiveDeviceUser, {
            context: scopedContext,
            signal: controller.signal,
            isCurrent
        });
        return ()=>{
            active = false;
            controller.abort();
        };
    }, [
        effectiveDeviceUser,
        initFn,
        requestKey
    ]);
}


/***/ }),

/***/ 50360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1646);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(90948);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61906);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34745);
/* harmony import */ var src_api_dashboard__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95629);
/* harmony import */ var src_api_android__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19630);
/* harmony import */ var src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(82017);
/* harmony import */ var src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26771);
/* harmony import */ var src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(74743);














dayjs__WEBPACK_IMPORTED_MODULE_3___default().extend((dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_4___default()));
// 自定义隐藏滚动条且保留滚动特性(div
const ScrollDiv = (0,_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)("div")({
    "@media (max-width: 600px)": {
        "-msOverflowStyle": "none",
        /* 适用于 IE 和 Edge */ scrollbarWidth: "none",
        /* 适用于 Firefox */ "&::-webkit-scrollbar": {
            display: "none"
        }
    }
});
// 自定义隐藏滚动条且保留滚动特性(ol
const ScrollOl = (0,_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)("ol")({
    "-msOverflowStyle": "none",
    /* 适用于 IE 和 Edge */ scrollbarWidth: "none",
    /* 适用于 Firefox */ "&::-webkit-scrollbar": {
        display: "none"
    }
});
const ScreenTime = ()=>{
    const { t , locale  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)("common");
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useDispatch */ .I0)();
    const [showIndex, setShowIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(-1) // 悬浮圆柱体时显示的下标
    ;
    const [totalWidth, setTotalWidth] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0) // 柱状体显示区域总宽度
    ;
    const [totalHeight, setTotalHeight] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0) // 柱状体显示区域总高度
    ;
    const [highestTime, setHighestTime] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0) //最高应用使用时长
    ;
    const [smallWidth, setSmallWidth] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0) // 单个圆柱体宽度
    ;
    const [smallWidth2, setSmallWidth2] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0) // 单个圆柱体宽度(不包含边距)
    ;
    const [spanToRight, setSpanToRight] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true) // 悬浮内容方向
    ;
    const [spanToTop, setSpanToTop] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0) // 悬浮内容距顶部距离
    ;
    const [clickIndex, setClickIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        index: -1,
        state: 0
    }) // 移动端柱状条点击状态
    ;
    const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null) // 柱状容器
    ;
    const showIndexRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(showIndex) // 下标存储
    ;
    const [innerWidth, setInnerWidth] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0) // 屏幕实时宽度
    ;
    const [isLoading, setIsLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true) //正在加载获取数据
    ;
    const [allData, setAllData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]) //所有数据
    ;
    const [showData, setShowData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]) //展示数据
    ;
    const [totalSeconds, setTotalSeconds] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0) // 所有app的使用时长秒数
    ;
    const [averageSeconds, setAverageSeconds] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0) // app平均使用时间
    ;
    const [allApp, setAllApp] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]) // 全部安装的app
    ;
    const loadScreenTimeData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(async function(deviceUdid) {
        let { signal , isCurrent  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const requestOptions = signal ? {
            signal
        } : undefined;
        try {
            var ref, ref1;
            const [usageResponse, appResponse] = await Promise.all([
                (0,src_api_dashboard__WEBPACK_IMPORTED_MODULE_8__/* .getLocalAndroidAll */ .gH)({
                    username: (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_13__/* .readUserEmail */ .t)(),
                    params: {
                        category: "APP_USAGE",
                        offset: 0,
                        limit: 200,
                        deviceUdid
                    }
                }, requestOptions),
                (0,src_api_dashboard__WEBPACK_IMPORTED_MODULE_8__/* .getLocalAndroidAll */ .gH)({
                    username: (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_13__/* .readUserEmail */ .t)(),
                    params: {
                        category: "INSTALLED_APP",
                        offset: 0,
                        limit: 200,
                        deviceUdid
                    }
                }, requestOptions),
                (0,src_api_android__WEBPACK_IMPORTED_MODULE_9__/* .androidLocalRefresh */ .DF)({
                    device_id: deviceUdid,
                    type: "43"
                }).catch(console.error)
            ]);
            if (isCurrent && !isCurrent()) return;
            setAllData([
                ...((ref = usageResponse.data.contents) === null || ref === void 0 ? void 0 : ref.data) || []
            ]);
            setAllApp([
                ...((ref1 = appResponse.data) === null || ref1 === void 0 ? void 0 : ref1.contents) || []
            ]);
        } catch (e) {
            if (isCurrent && !isCurrent() || (e === null || e === void 0 ? void 0 : e.code) === "ERR_CANCELED") return;
            ;
        } finally{
            if (!isCurrent || isCurrent()) setIsLoading(false);
        }
    }, []);
    // 设备切换时重置屏幕使用时间并重新拉数
    (0,src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_10__/* .useDeviceScopedInit */ .A)((0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((_, param)=>{
        let { context , signal , isCurrent  } = param;
        const deviceUdid = (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_13__/* .readLocalDeviceUdid */ .S)(context);
        if (!deviceUdid) return;
        setIsLoading(true);
        setAllData([]);
        setShowData([]);
        setAllApp([]);
        setTotalSeconds(0);
        setAverageSeconds(0);
        setHighestTime(0);
        setShowIndex(-1);
        setClickIndex({
            index: -1,
            state: 0
        });
        loadScreenTimeData(deviceUdid, {
            signal,
            isCurrent
        });
    }, [
        loadScreenTimeData
    ]));
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!allData.length) return;
        const maxSeconds = Math.max(...allData.map((item)=>item.seconds || 0));
        const newData = allData.map((item)=>{
            const app = allApp.find((a)=>a.name === item.className);
            return {
                ...item,
                iconUrl: app ? app.iconUrl : "",
                percent: maxSeconds ? (item.seconds / maxSeconds * 100).toFixed(2) : 0
            };
        }).sort((a, b)=>b.seconds - a.seconds);
        setHighestTime(maxSeconds);
        setShowData(newData);
    }, [
        allData,
        allApp
    ]);
    // 获取平均使用时间
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let total = 0;
        let sum = 0;
        allData.forEach((item)=>{
            total += item.seconds;
            sum++;
        });
        setTotalSeconds(total);
        setAverageSeconds(total / sum);
    }, [
        allData
    ]);
    // 初始化每个柱状体的宽度
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let totalWidth = 0;
        if (contentRef.current) {
            totalWidth = contentRef.current.offsetWidth;
            setTotalWidth(totalWidth);
            setTotalHeight(contentRef.current.clientHeight);
            setSmallWidth(totalWidth / allData.length);
            setSmallWidth2(totalWidth / allData.length - 10);
        }
    }, [
        innerWidth
    ]);
    // 监听鼠标位置
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handleMouseY = (event)=>{
            if (contentRef.current && showIndexRef.current !== -1) {
                const container = contentRef.current;
                // 获取容器的位置信息
                const rect = container.getBoundingClientRect();
                // 计算鼠标距离容器顶部的高度
                const mouseHeight = event.clientY - rect.top;
                // 确保鼠标高度在容器范围内
                const boundedHeight = Math.max(0, Math.min(mouseHeight, rect.height));
                setSpanToTop(boundedHeight);
            }
        };
        if (contentRef.current) contentRef.current.addEventListener("mousemove", handleMouseY);
        return ()=>{
            if (contentRef.current) contentRef.current.removeEventListener("mousemove", handleMouseY);
        };
    }, []);
    // 计算柱状条高度
    const calculateSmallHeight = (item, type)=>{
        let rate = 0;
        if (type === 0) {
            rate += item;
        } else rate = item;
        return totalHeight * rate / 100;
    };
    // 悬浮式修改各状态
    const changeSpanMouseOver = (index, type)=>{
        if (type === 0) {
            const nowWidth = smallWidth * (index + 1);
            if (nowWidth + 213 > totalWidth && innerWidth > 990) setSpanToRight(false);
            else if (46 * (index + 1) + 150 > totalWidth && innerWidth < 990) setSpanToRight(false);
            setShowIndex(index);
            showIndexRef.current = index;
        } else {
            setSpanToRight(true);
            setShowIndex(-1);
            showIndexRef.current = -1;
        }
    };
    const convertToEvenMinutes = (seconds)=>{
        let minutes = Math.floor(seconds / 60);
        if (minutes < 1) return 1;
        // 往下取偶数
        if (minutes % 2 !== 0) {
            minutes = minutes - 1;
        }
        return minutes < 1 ? 1 : minutes;
    };
    // 监听屏幕宽度
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handleWidth = ()=>{
            setInnerWidth(window.innerWidth);
        };
        handleWidth();
        window.addEventListener("resize", handleWidth);
        return ()=>{
            window.removeEventListener("resize", handleWidth);
        };
    }, []);
    // 获取当前语种的dayjs
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handleLocale = async ()=>{
            switch(locale){
                case "fr":
                    await __webpack_require__.e(/* import() */ 6023).then(__webpack_require__.t.bind(__webpack_require__, 96023, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("fr");
                    break;
                case "jp":
                    await __webpack_require__.e(/* import() */ 6831).then(__webpack_require__.t.bind(__webpack_require__, 76831, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("ja");
                    break;
                case "es":
                    await __webpack_require__.e(/* import() */ 7763).then(__webpack_require__.t.bind(__webpack_require__, 91844, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("es");
                    break;
                case "de":
                    await __webpack_require__.e(/* import() */ 790).then(__webpack_require__.t.bind(__webpack_require__, 80790, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("de");
                    break;
                case "it-ch":
                    await __webpack_require__.e(/* import() */ 5551).then(__webpack_require__.t.bind(__webpack_require__, 15551, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("it");
                    break;
                case "pt":
                    await __webpack_require__.e(/* import() */ 5001).then(__webpack_require__.t.bind(__webpack_require__, 15001, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("pt");
                    break;
                case "kr":
                    await __webpack_require__.e(/* import() */ 9132).then(__webpack_require__.t.bind(__webpack_require__, 19132, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("ko");
                    break;
                case "ar":
                    await __webpack_require__.e(/* import() */ 3939).then(__webpack_require__.t.bind(__webpack_require__, 63939, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("ar");
                    break;
                case "tr":
                    await __webpack_require__.e(/* import() */ 3035).then(__webpack_require__.t.bind(__webpack_require__, 73035, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("tr");
                    break;
                default:
                    await __webpack_require__.e(/* import() */ 5054).then(__webpack_require__.t.bind(__webpack_require__, 25054, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("en");
            }
        };
        handleLocale();
    }, [
        locale
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const title = t("Screen Time");
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_7__/* .setCurrentTab */ .Lw)(title));
        return ()=>dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_7__/* .setCurrentTab */ .Lw)(""));
    }, [
        dispatch,
        t
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ScrollDiv, {
            className: "w-full !h-[calc(var(--vh2)*100-215px)] smj:!h-[calc(var(--vh2)*100-90px)] [box-shadow:0px_0px_12px_0px_#00000021] rounded-[10px] overflow-x-hidden overflow-y-auto flex smj:flex-col relative",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "w-full text-left text-[18px] text-[#000000] font-[600] leading-[27px] mt-[42px] smj:mt-5 mb-[6px] ml-[20px] smjs:hidden smj:order-2 ".concat(allData.length == 0 && "hidden"),
                    children: t("App usage")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScrollOl, {
                    className: "w-full h-auto smjs:!w-[327px] smjs:[border-right:1px_solid_#E7E8EC] smjs:overflow-auto py-[10px] smj:order-3",
                    children: showData.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            className: "h-[60px] flex items-center p-[9px_9px_14px_12px] smj:p-[10px_14px_14px] mx-[3px] smj:mx-[6px] hover:bg-[#F4F5F7] hover:rounded-[6px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    src: "https://cos.spyx.com/" + item.iconUrl,
                                    alt: item.className,
                                    width: 32,
                                    height: 32,
                                    className: "w-[32px] h-[32px] mr-3 rounded-[50%]"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "w-full flex flex-col justify-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "h-[21px] flex justify-between items-center",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-[14px] text-[#4D5976] font-[500] leading-[21ps]",
                                                    children: item.className
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "text-[12px] text-[#80889D] font-[400] leading-[18px]",
                                                    children: "".concat(dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(item.seconds, "seconds").hours() > 0 ? dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(item.seconds, "seconds").hours() < 10 ? "0" + dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(item.seconds, "seconds").hours() + "h " : dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(item.seconds, "seconds").hours() + "h " : "", "\n                      ").concat(dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(item.seconds, "seconds").minutes() < 10 ? "0" + dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(item.seconds, "seconds").minutes() : dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(item.seconds, "seconds").minutes(), "m\n                      ").concat(dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(item.seconds, "seconds").seconds() < 10 ? "0" + dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(item.seconds, "seconds").seconds() : dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(item.seconds, "seconds").seconds(), "s")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-full h-[2px] bg-[#EDEEF0] mt-2 mb-1 overflow-hidden",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "h-[2px] bg-[#1A90FF]",
                                                style: {
                                                    width: "".concat(item.seconds / totalSeconds * 100, "%"),
                                                    minWidth: "".concat(item.seconds > 0 ? "2" : "0", "%")
                                                }
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, index))
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "smj:w-full smjs:w-[calc(100%-327px)] pt-[30px] smj:pt-[14px] px-[90px] smj:px-[12px] smj:order-1 smjs:overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "w-full text-center text-[18px] text-[#000000] font-[600] leading-[27px] smjs:hidden",
                            children: t("Screen Time")
                        }),
                        allData.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-auto h-max smj:mt-[20px] smj:pl-[8px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-[18px] text-[#334062] font-[700] leading-[27px] smjs:mb-2",
                                    children: t("Todays")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-[14px] smj:text-[16] smj:leading-[24px] text-[#666666] font-[700]",
                                    children: t("Average App Screen time")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "smjs:h-[130px] smj:mt-[14px] smj:mb-[25px] flex flex-wrap items-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("time", {
                                        className: "text-[40px] smj:text-[24px] smj:leading-[36px] text-[#334062] font-[700] mr-4",
                                        children: "".concat(dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(averageSeconds, "seconds").hours() > 0 ? dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(averageSeconds, "seconds").hours() < 10 ? "0" + dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(averageSeconds, "seconds").hours() + "h " : dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(averageSeconds, "seconds").hours() + "h " : "", "\n                ").concat(dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(averageSeconds, "seconds").minutes() < 10 ? "0" + dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(averageSeconds, "seconds").minutes() : dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(averageSeconds, "seconds").minutes(), "m\n                ").concat(dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(averageSeconds, "seconds").seconds() < 10 ? "0" + dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(averageSeconds, "seconds").seconds() : dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(averageSeconds, "seconds").seconds(), "s")
                                    })
                                })
                            ]
                        }),
                        allData.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ol", {
                                    className: "w-8 h-full grid grid-cols-1 grid-rows-[repeat(3,1fr)] gap-[233px] smj:gap-[87px] items-start text-[12px] smj:text-[10px] text-[#A5A5A5] font-[400] leading-[18px] smj:leading-[15px] mr-3 smj:mr-[5px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            className: "w-full text-right text-nowrap",
                                            children: [
                                                convertToEvenMinutes(highestTime),
                                                "m"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            className: "w-full text-right text-nowrap",
                                            children: [
                                                convertToEvenMinutes(highestTime) / 2,
                                                "m"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: "w-full text-right text-nowrap",
                                            children: "0"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScrollDiv, {
                                    className: "w-[calc(100%-32px)] smj:overflow-x-auto smj:h-[245px]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-full smj:w-auto h-[515px] smj:h-[215px] flex",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            ref: contentRef,
                                            className: "w-full h-full [border-left:2px_dashed_#E8E7EC] smj:[border-left:1px_dashed_#E8E7EC] [border-bottom:2px_dashed_#E8E7EC] smj:[border-bottom:1px_dashed_#E8E7EC] relative pl-[6px]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-full h-full absolute z-[54] ".concat(clickIndex.state === 0 ? "hidden" : ""),
                                                    onClick: ()=>{
                                                        changeSpanMouseOver(clickIndex.index, clickIndex.state);
                                                        setClickIndex((old)=>({
                                                                ...old,
                                                                state: 0
                                                            }));
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                                                    className: "w-full h-full flex items-end",
                                                    children: showData.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            className: "w-full flex flex-col justify-end relative max-w-[60px] smj:!w-[36px] smj:flex-shrink-0",
                                                            style: {
                                                                width: "".concat(smallWidth, "px"),
                                                                height: "100%"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "bg-[#F1E600] transition-[height] duration-300 ease-linear cursor-pointer z-[56] smj:!w-[30px]",
                                                                    style: {
                                                                        width: "calc(100% - 10px)",
                                                                        height: "".concat(item.percent, "%")
                                                                    },
                                                                    onMouseOver: ()=>innerWidth > 990 && changeSpanMouseOver(index, 0),
                                                                    onMouseOut: ()=>innerWidth > 990 && changeSpanMouseOver(index, 1),
                                                                    onClick: ()=>{
                                                                        if (innerWidth <= 990) {
                                                                            if (clickIndex.index === index) {
                                                                                changeSpanMouseOver(index, clickIndex.state);
                                                                                setClickIndex((old)=>({
                                                                                        ...old,
                                                                                        state: old.state === 0 ? 1 : 0
                                                                                    }));
                                                                            } else {
                                                                                changeSpanMouseOver(index, 0);
                                                                                setClickIndex((old)=>({
                                                                                        index,
                                                                                        state: 1
                                                                                    }));
                                                                            }
                                                                        }
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                    className: "w-[max-content] text-nowrap min-h-[30px] p-3 bg-[#F5F6FA] rounded-[6px] absolute [box-shadow:0px_0px_12px_0px_#00000021] ".concat(showIndex !== index ? "hidden" : "", " z-[58]"),
                                                                    style: {
                                                                        translate: "".concat(spanToRight ? smallWidth + "px" : "-100%"),
                                                                        top: "".concat(innerWidth > 990 ? "".concat(spanToTop - (totalHeight - calculateSmallHeight(item, 0)) - 21, "px") : "unset")
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            className: "flex items-center mb-2",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                                                    src: "https://cos.spyx.com/" + item.iconUrl,
                                                                                    width: 20,
                                                                                    height: 20,
                                                                                    alt: "",
                                                                                    className: "mr-2"
                                                                                }),
                                                                                item.className
                                                                            ]
                                                                        }),
                                                                        t("Total time"),
                                                                        ":",
                                                                        " ",
                                                                        "".concat(dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(item.seconds, "seconds").hours() > 0 ? dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(item.seconds, "seconds").hours() < 10 ? "0" + dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(item.seconds, "seconds").hours() + "h " : dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(item.seconds, "seconds").hours() + "h " : "", "\n                                ").concat(dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(item.seconds, "seconds").minutes() < 10 ? "0" + dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(item.seconds, "seconds").minutes() : dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(item.seconds, "seconds").minutes(), "m\n                                ").concat(dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(item.seconds, "seconds").seconds() < 10 ? "0" + dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(item.seconds, "seconds").seconds() : dayjs__WEBPACK_IMPORTED_MODULE_3___default().duration(item.seconds, "seconds").seconds(), "s"),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                                            className: "grid grid-cols-1 gap-x-[30px] gap-y-[4px] mt-[8px] text-[12px] text-[#000000] font-[Poppins] font-[400] leading-[18px] select-none",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                                    className: "flex items-center cursor-pointer",
                                                                                    children: [
                                                                                        t("First open time"),
                                                                                        ": ",
                                                                                        dayjs__WEBPACK_IMPORTED_MODULE_3___default()(item.firstOpen).format("HH:mm:ss")
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                                    className: "flex items-center cursor-pointer",
                                                                                    children: [
                                                                                        t("Last close time"),
                                                                                        ": ",
                                                                                        dayjs__WEBPACK_IMPORTED_MODULE_3___default()(item.lastClose).format("HH:mm:ss")
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "w-full absolute -bottom-[26px] right-[5px] smj:right-[3px] flex justify-center z-100",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                                        src: "https://cos.spyx.com/" + item.iconUrl,
                                                                        width: 20,
                                                                        height: 20,
                                                                        alt: "",
                                                                        className: "w-[".concat(smallWidth2 * 0.4, "px] h-[").concat(smallWidth2 * 0.4, "px] smj:w-[20px] smj:h-[20px]")
                                                                    })
                                                                })
                                                            ]
                                                        }, index))
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
                }) : null,
                allData.length > 0 || isLoading || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-center px-5 absolute inset-0 flex justify-center items-center pointer-events-none",
                    children: [
                        t("It appears theres no data to show here yet"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        t("If data exists it may take up to 1 hour to download and appear"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        t("We suggest checking back in a little while")
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ScreenTime);


/***/ }),

/***/ 74249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentLoadingRoot":"ContentLoading_contentLoadingRoot__ypzGH","contentLoadingRootFullScreen":"ContentLoading_contentLoadingRootFullScreen__ZmB8e","contentLoadingSpinner":"ContentLoading_contentLoadingSpinner__4vCxU","content-loading-spin":"ContentLoading_content-loading-spin__K0YUP","contentLoadingLabel":"ContentLoading_contentLoadingLabel__S0w79"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,9774,2888,179], function() { return __webpack_exec__(92977); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);